module.exports = __webpack_public_path__ + "img/edenred-ecoCheque.caad3c10.png";